export default "__VITE_ASSET__eXvhBdn3__"